<template>
  <router-view></router-view>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
